import QuestionController from '../controllers/QuestionController';
import type { QuestionProp } from '../types/question';
import ComplexQuestionMapper from './ComplexQuestionMapper';
import ComponentMapper from './ComponentMapper';

type QuestionLibraryMapperProps = {
  component?: Record<string, any>;
  isParentShowing?: boolean;
};

/**
 * @typedef {object} QuestionLibraryMapperProps
 * @property {import('../types/component').QuestionLibraryElement} component
 *
 * @param {QuestionLibraryMapperProps} props
 * @returns {JSX.Element}
 */
export default function QuestionLibraryMapper({
  component,
  isParentShowing = true,
}: QuestionLibraryMapperProps) {
  const { componentType } = component;
  const questionLibraryMapper = {
    component: <ComponentMapper component={component} />,
    complexQuestion: (
      <ComplexQuestionMapper
        question={component}
        isParentShowing={isParentShowing}
      />
    ),
    question: (
      <QuestionController
        question={component as QuestionProp}
        isParentShowing={isParentShowing}
      />
    ),
  };

  return (
    questionLibraryMapper[componentType] ?? (
      <p>
        No component with type of <strong>{componentType}</strong>
      </p>
    )
  );
}
